// App.js
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Home from './components/pages/Home';
import Login from './components/pages/Login';
import Register from './components/pages/Register';
import Contact from './components/pages/Contact';
import Stock from './components/pages/Stock';
import Subastas from './components/pages/subastas';
import MisOfertas from './components/pages/MisOfertas';
import Ajustes from './components/pages/Ajustes';
import Credito from './components/pages/Credito';
import InfoCar from './components/pages/InfoCar';
import Infosubasta from './components/pages/infosubasta'
import Politics from './components/pages/Politics';
import Sell from './components/pages/Sell';
import AllCars from './components/pages/AllCars';
import Notifications from './components/pages/Notifications';
import MyCars from './components/pages/MyCars';
import AllUsers from './components/pages/AllUsers';
import Boletin from './components/pages/Boletin';
import BoletinSubastas from './components/pages/BoletinSubastas';
import AllCarsAdmin from './components/pages/AllCarsAdmin';
import EditContent from './components/pages/EditContent';
import AddCar from './components/pages/AddCar';
import EditCar from './components/pages/EditCar';
import CreateAuction from './components/pages/CreateAuction';
import AuctionForm from './components/pages/AuctionForm';
import VerificationForm from './components/pages/VerificationForm';
import AboutUs from './components/pages/AboutUs';
import Avisos from './components/pages/Avisos';
import Banner from './components/pages/Banners';
import NotificationsAdmin from './components/pages/NotificationsAdmin';
import AuctionReports from './components/pages/AuctionReports';
import AuctionReportDetail from './components/pages/AuctionReportDetail';
import VerificationRequests from './components/pages/VerificationRequests';
import CarAdRequests from './components/pages/CarAdRequests';
import AdSpaceRequest from './components/pages/AdSpaceRequest';
import AdSpaceRequests from './components/pages/AdSpaceRequests';
import LoadingScreen from './components/LoadingScreen';
import ScrollRestoration from './components/ScrollRestoration';

import { StockProvider } from './context/StockContext';

import './App.css';

const AppContent = () => {
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    setLoading(true);
    // Simulando una carga para demostración
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, [location]);

  return (
    <>
      <ScrollRestoration />
      {loading && <LoadingScreen />}
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/login' element={<Login />} />
        <Route path='/register' element={<Register />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/stock' element={<Stock />} />
        <Route path='/subastas' element={<Subastas />} />
        <Route path='/misofertas' element={<MisOfertas />} />
        <Route path='/ajustes' element={<Ajustes />} />
        <Route path='/credit' element={<Credito />} />
        <Route path='/info/:id' element={<InfoCar />} />
        <Route path='/subasta/:id' element={<Infosubasta />} />
        <Route path='/politicas' element={<Politics />} />
        <Route path='/sell' element={<Sell />} />
        <Route path="/allcars" element={<AllCars />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/mycars" element={<MyCars />} />
        <Route path="/allusers" element={<AllUsers />} />
        <Route path="/boletin" element={<Boletin />} />
        <Route path="/boletin-subastas" element={<BoletinSubastas />} />
        <Route path="/allcarsa" element={<AllCarsAdmin />} />
        <Route path="/editcontent" element={<EditContent />} />
        <Route path="/addcar" element={<AddCar />} />
        <Route path="/editcar" element={<EditCar />} />
        <Route path="/createauction" element={<CreateAuction />} />
        <Route path="/createauction/:id" element={<AuctionForm />} />
        <Route path="/verificar" element={<VerificationForm />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/avisos" element={<Avisos />} />
        <Route path="/banner" element={<Banner />} />
        <Route path="/notificationsadmin" element={<NotificationsAdmin />} />
        <Route path="/auctionreports" element={<AuctionReports />} />
        <Route path="/auctionreports/:id" element={<AuctionReportDetail />} />
        <Route path="/verificationrequests" element={<VerificationRequests />} />
        <Route path="/caradrequests" element={<CarAdRequests />} />
        <Route path="/adspacerequests" element={<AdSpaceRequests />} />
        <Route path="/advertising" element={<AdSpaceRequest />} />
      </Routes>
    </>
  );
};

function App() {
  return (
    <StockProvider>
      <Router>
        <AppContent />
      </Router>
    </StockProvider>
  );
}

export default App;
